interface WindowListIconProps {
  size?: number
  className?: string
}

/**
 * "Liste" window-mode icon — a document panel with list lines. Stroke uses
 * `currentColor` so the ButtonGroup's per-state colour (grey → violet) applies.
 */
export const WindowListIcon = ({ size = 16, className }: WindowListIconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5 4.5H8H11M5 7.5H8H11M4.33333 1.5H11.6667C12.403 1.5 13 2.09695 13 2.83333V13.1667C13 13.903 12.403 14.5 11.6667 14.5H4.33333C3.59695 14.5 3 13.903 3 13.1667L3 2.83333C3 2.09695 3.59695 1.5 4.33333 1.5Z"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
